module.exports = __webpack_public_path__ + "img/top-up.b6115e30.png";